export const companiesSubMenu = [{
  path: '/companies/list',
  component: () => import('@/views/companies/list.vue'),
  name: 'dealerManagement.company.title',
  meta: {
    title: 'dealerManagement.company.title',
    roles: ['Super Admin', 'Regional Manager', 'Zonal Manager'],
    noCache: true,
    icon: 'building'
  }
}, {
  path: '/companies/edit/:id(\\d+)',
  component: () => import('@/views/companies/manage.vue'),
  name: 'dealerManagement.company.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'dealerManagement.company.manage',
    noCache: true,
    activeMenu: '/companies/list',
    hidden: true
  }
}, {
  path: '/companies/add/',
  component: () => import('@/views/companies/manage.vue'),
  name: 'dealerManagement.company.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'dealerManagement.company.manage',
    noCache: true,
    activeMenu: '/companies/list',
    hidden: true
  }
}];